<script lang="ts" setup>
import { computed } from 'vue'

import AButton from '@/components/atoms/AButton/index.vue'

/**
 * Props
 */
type Props = {
  href?: string
  underline?: boolean
  fontSize?: 'small' | 'medium'
}
const props = withDefaults(defineProps<Props>(), {
  href: undefined,
  underline: true,
  fontSize: 'small',
})

const fontSizeClass = computed(() => {
  return props.fontSize === 'medium' ? 'text-link--medium' : 'text-link--small'
})
</script>

<template>
  <AButton
    variant="text"
    :href="props.href"
    :class="[
      'text-link',
      fontSizeClass,
      {
        underline: props.underline,
      },
    ]"
  >
    <slot />
  </AButton>
</template>

<style lang="scss" scoped>
.text-link {
  display: inline-flex;
  align-items: center;
  min-width: fit-content;
  height: 25px;
  padding: 0 !important;
  color: rgb(var(--v-theme-primary));
  letter-spacing: normal;
  background: none;

  &:hover {
    opacity: 0.7;
  }

  &.underline {
    text-decoration: underline;
  }
}

.text-link--small {
  :deep(.v-btn__content) {
    font-size: 12px !important;
  }
}

.text-link--medium {
  :deep(.v-btn__content) {
    font-size: 14px !important;
  }
}
</style>
